<template>
  <el-container class="contents" style="display: block;">
    <el-container class="l-login" style="display: block;">
		<div class="title">用户登录</div>
		<div>
			<el-input
				placeholder="用户名"
				prefix-icon="el-icon-user"
				v-model="name">
			</el-input>
		</div>

		<div>
			<el-input
				placeholder="密码"
				prefix-icon="el-icon-key"
				v-model="password" show-password>
			</el-input>
		</div>
		<div class="doLogin"  @click="login()">登录</div>
	</el-container>
  <!-- <el-table
   	:data="ceshi"
   	style="width: 100%;"
   	class="el-table"
   	border
   	>
   	<el-table-column
         label="编号"
          align="center"
         width="50">
         <template slot-scope="scope">
         	{{indexIds(1,scope.$index)}}
         </template>
   	</el-table-column>


   </el-table> -->
  </el-container>
</template>


<script>

  export default {
    data() {
      return {
        name:'',
        password:'',
        uIp:'',

        url:this.$store.getters.getUrl,


      };
    },
    created() {
		//var cip = returnCitySN["cip"];
		//this.uIp = cip


    },

	methods:{



		login(){
      this.zhuanquan = true;
      setTimeout(this.zhuanquan = false,1000);
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.name,
					password:this.password,
					uIp:this.uIp
				},
				url:'https://y31p.yoooooo.com/index.php/index/data/login'
			})
			.then(res=>{
				if(res.data.code == 200){

					window.localStorage.setItem('token',res.data.data.token);
					window.localStorage.setItem('id',res.data.data.user.id);
					window.localStorage.setItem('name',res.data.data.user.user_name);
					window.localStorage.setItem('role',res.data.data.user.role);
					this.$store.dispatch('disName');
					this.$store.dispatch('disRole');

          if(res.data.data.user.role =='web'||res.data.data.user.role =='fenxi'){

            this.$router.push({ path: '/Ac' })
          }else if(res.data.data.user.role =='webz'){

            this.$router.push({ path: '/Equipmentx' })
          }else if(res.data.data.user.role =='ui'){

            this.$router.push({ path: '/Dz' })
          }else if(res.data.data.user.role =='yuzhou'){

            this.$router.push({ path: '/Ac' })
          }else if(res.data.data.user.role =='adminj'){

            this.$router.push({ path: '/User' })
          }else if(res.data.data.user.role =='shijian'){

            this.$router.push({ path: '/Qwdata' })
          }else{

            this.$router.push({ path: '/Lable' })
          }

				}else if(res.data.code == 204){
					this.msg('无权限','error');
				}else{
          this.msg('用户名密码错误','error');
        }

			})
			.catch(err=>{

			});
		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>

	.l-login{

		margin-left: 40%;
		margin-top: 200px;
	}
	.l-login div{
		width: 400px;
		margin-bottom: 10px;
	}
	.title{
		width: 400px;
		color: orange;
		font-size: 30px;
		text-align: center;
	}
	.doLogin{
		width: 400px;
		height: 40px;
		color: #fff;
		background: orange;
		line-height: 40px;
		text-align: center;
	}


</style>



// WEBPACK FOOTER //
// src/components/main/login.vue